import React from 'react';
import { Image, Header, Button } from 'semantic-ui-react';
import { Link } from 'react-router-dom';
import fourOfour from '../../assets/images/404.png';
import './NoMatch.css';


const NoMatch = () => {
  return (
    <div className="NoMatch">
      <Header as="h1" className="NoMatch__Header">De pagina die je zocht is niet beschikbaar.</Header>
      <Link to="/">
        <Button className="NoMatch__Button">Klik hier om terug te gaan naar de homepagina.</Button>
      </Link>
      <Image src={fourOfour} size="large" centered className="NoMatch__Image" />
    </div>
  );
};

export default NoMatch;



// WEBPACK FOOTER //
// ./src/components/NoMatch/index.js